import {create} from 'zustand';

const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed';

const loadCollapsed = () => {
  try {
    return { spectra: false, spark: false, ...JSON.parse(localStorage.getItem(SIDEBAR_COLLAPSED_KEY) || '{}') };
  } catch {
    return { spectra: false, spark: false };
  }
};

const UIStore = create((set) => ({
  activeMode: "global",
  showSidebar: window.innerWidth > 1024,
  showDetails: true,
  placeHolder: "",
  recognitionRef: null,
  modeRef: "global",
  scrollRef: null,
  sideRef: null,
  idleTimeout : 10000,
  idleTimeoutRef: null,
  isRecording: false,
  orgAvailable: null,
  orgModeError: null,
  setShowDetails: (value) => set({ showDetails: value }),
  setIsRecording: (value) => set({ isRecording: value }),
  setActiveMode: (mode) => set({ activeMode: mode }),
  setShowSidebar: (value) => set({ showSidebar: value }),
  setPlaceHolder: (text) => set({ placeHolder: text }),
  setOrgAvailable : (value) => set({ orgAvailable : value}),
  setOrgModeError: (value) => set({ orgModeError: value }),
  setModeRef : (value) => set({modeRef : value}),

  loadingAuth: false,
  setLoadingAuth: (value) => set({ loadingAuth: value }),

  // Sidebar section collapse state (persisted) + search filter
  sidebarCollapsed: loadCollapsed(),
  toggleSidebarSection: (key) =>
    set((state) => {
      const next = { ...state.sidebarCollapsed, [key]: !state.sidebarCollapsed[key] };
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, JSON.stringify(next));
      return { sidebarCollapsed: next };
    }),
  sidebarQuery: "",
  setSidebarQuery: (value) => set({ sidebarQuery: value }),

  // When true, the sidebar width / main-content margin change instantly
  // (no spring). Used to decouple the Nebula auto-collapse from the heavy
  // mode-switch render so the animation doesn't compete with it.
  suppressSidebarAnimation: false,
  setSuppressSidebarAnimation: (value) => set({ suppressSidebarAnimation: value }),

  toggleSidebar: () =>
    set((state) => ({ showSidebar: !state.showSidebar })),
}));

export default UIStore;
